"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Cigarette = void 0;

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _isMatch2 = _interopRequireDefault(require("lodash/isMatch"));

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _userflow = _interopRequireDefault(require("@lt/components/themes/userflow"));

var _styles = require("./styles");

var _context = require("./context");

var _constants = require("./constants");

var _FormDeparturePicker = _interopRequireDefault(require("./components/FormDeparturePicker"));

var _FormDatePicker = _interopRequireDefault(require("./components/FormDatePicker"));

var _FormDestinationPicker = _interopRequireDefault(require("./components/FormDestinationPicker"));

var _FormTouristsPicker = _interopRequireDefault(require("./components/FormTouristsPicker"));

var _BackWizardButton = _interopRequireDefault(require("./components/BackWizardButton"));

var _CloseWizardButton = _interopRequireDefault(require("./components/CloseWizardButton"));

var _SearchButton = _interopRequireDefault(require("./components/SearchButton"));

var _hooks = require("./hooks");

var _buildLandParams = require("./utils/buildLandParams");

var _validate = require("./validate");

var _utils = require("./utils");

var _withApiContext = require("../../context/hocs/withApiContext");

var _useReadLocalStorageWithDTO = _interopRequireDefault(require("./hooks/useReadLocalStorageWithDTO"));

var _savedDepartureDTO = require("./utils/savedDepartureDTO");

var _format = _interopRequireDefault(require("date-fns/format"));

var _excluded = ["values", "initialValues", "isValid"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * DTO делает следующие преобразования данных:
 * 1) Подогнал начальные даты в полночь
 */
var initialValuesDTO = function initialValuesDTO(initialValues) {
  if (initialValues.datepicker && (initialValues.datepicker.left.date || initialValues.datepicker.right.date)) {
    return _objectSpread(_objectSpread({}, initialValues), {}, {
      datepicker: _objectSpread(_objectSpread({}, initialValues.datepicker), {}, {
        left: _objectSpread(_objectSpread({}, initialValues.datepicker.left), {}, {
          date: initialValues.datepicker.left.date ? new Date((0, _format["default"])(initialValues.datepicker.left.date, 'MM/dd/yyyy')) : initialValues.datepicker.left.date
        }),
        right: _objectSpread(_objectSpread({}, initialValues.datepicker.right), {}, {
          date: initialValues.datepicker.right.date ? new Date((0, _format["default"])(initialValues.datepicker.right.date, 'MM/dd/yyyy')) : initialValues.datepicker.right.date
        })
      })
    });
  }

  return _objectSpread({}, initialValues);
};

var openInNewTab = function openInNewTab(redirectUrl) {
  setTimeout(function () {
    window.open(redirectUrl, '_blank');
  });
};

var BaseCigarette = function BaseCigarette(_ref) {
  var _ref$searchType = _ref.searchType,
      searchType = _ref$searchType === void 0 ? _constants.SEARCH_TYPE_NAMES.PACKAGE : _ref$searchType,
      mobileVariant = _ref.mobileVariant,
      _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === void 0 ? _constants.INITIAL_VALUES_FORMIK : _ref$initialValues,
      _ref$host = _ref.host,
      host = _ref$host === void 0 ? window.location.origin : _ref$host,
      onSubmit = _ref.onSubmit,
      isMainPage = _ref.isMainPage,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      setIsWizardOpen = _ref.setIsWizardOpen,
      setBodyLocked = _ref.setBodyLocked,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      onChange = _ref.onChange,
      trackSubmit = _ref.trackSubmit,
      _ref$isWidget = _ref.isWidget,
      isWidget = _ref$isWidget === void 0 ? false : _ref$isWidget,
      _ref$isWhiteLabel = _ref.isWhiteLabel,
      isWhiteLabel = _ref$isWhiteLabel === void 0 ? false : _ref$isWhiteLabel,
      initialOpenedField = _ref.initialOpenedField,
      openNewTab = _ref.openNewTab,
      isSearcher = _ref.isSearcher;

  /**
   * Данными двумя строчками скидываем время в датах в полночь,потому что мы оперируем датами с полночью
   */
  var formatInitialValues = initialValuesDTO(initialValues);
  var isWizard = mobileVariant === 'wizard';
  var isHotelVariant = variant === 'hotel';
  var isMobile = !!mobileVariant;
  var isPackage = searchType === _constants.SEARCH_TYPE_NAMES.PACKAGE;
  var isTrip = searchType === _constants.SEARCH_TYPE_NAMES.TRIP;

  var _useFetchDepartures = (0, _hooks.useFetchDepartures)(initialValues.departure),
      departures = _useFetchDepartures.departures,
      departuresLoading = _useFetchDepartures.loading;

  var _useAutocomplete = (0, _hooks.useAutocomplete)(searchType, isWizard),
      startOptions = _useAutocomplete.startOptions,
      fullOptions = _useAutocomplete.fullOptions,
      foundGroupedOptions = _useAutocomplete.foundGroupedOptions,
      setParams = _useAutocomplete.setParams,
      setDepartureValue = _useAutocomplete.setDepartureValue,
      destinationsLoading = _useAutocomplete.loading;

  var cigaretteRef = (0, _react.useRef)(null);
  var newTabRef = (0, _react.useRef)(null);

  var _useSearchLand = (0, _hooks.useSearchLand)({
    newTabRef: newTabRef.current
  }),
      setSubmitParams = _useSearchLand.setParams,
      landLoading = _useSearchLand.loading;

  var savedDeparture = (0, _useReadLocalStorageWithDTO["default"])(_constants.storageKeys.departure, _savedDepartureDTO.savedDepartureDTO);

  var submitHandler = function submitHandler(values) {
    // сабмит сработает только после валидации, когда все поля будут заполнены
    var landParams = (0, _buildLandParams.buildLandParams)(_objectSpread(_objectSpread({}, values), {}, {
      host: host,
      searchType: searchType
    }));

    if (trackSubmit) {
      trackSubmit({
        values: values,
        searchType: searchType
      });
    }

    if (isTrip) {
      var _ref2 = landParams,
          redirectUrl = _ref2.redirectUrl;
      openInNewTab(redirectUrl);
      return;
    }

    if (openNewTab) {
      var _newTabRef$current;

      newTabRef.current = window.open();
      (_newTabRef$current = newTabRef.current) === null || _newTabRef$current === void 0 ? void 0 : _newTabRef$current.focus();
    }

    if (onSubmit && !isTrip) {
      onSubmit(landParams);
    } else {
      setSubmitParams(landParams);
    }
  };
  /*
    При отложенной загрузке сигареты пользователь
    может кликнуть в превью кнопки поиска, и в таком
    случае в Formik должно отправляться событие сабмита
    https://formik.org/docs/guides/form-submission
   */


  (0, _react.useEffect)(function () {
    if (!cigaretteRef.current) return;

    if (initialOpenedField === 'submit') {
      cigaretteRef.current.handleSubmit();
    }
  }, [initialOpenedField]);
  return (
    /*#__PURE__*/
    // Решает конфликты при интеграции на сайт вместе с друой версией lt-components
    _react["default"].createElement(_userflow["default"], null, /*#__PURE__*/_react["default"].createElement(_context.CigaretteProvider, {
      isMobile: isMobile,
      isWizard: isWizard,
      setIsWizardOpen: setIsWizardOpen,
      initialOpenedField: initialOpenedField
    }, /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
      enableReinitialize: isHotelVariant,
      initialValues: _objectSpread(_objectSpread({}, formatInitialValues), {}, {
        departure: formatInitialValues.departure || savedDeparture || undefined
      }),
      validateOnChange: false,
      validateOnBlur: false,
      onSubmit: submitHandler,
      validate: isMobile ? undefined : function (values) {
        return (0, _validate.validate)(values, searchType);
      },
      innerRef: cigaretteRef
    }, function (_ref3) {
      var values = _ref3.values,
          initialValues = _ref3.initialValues,
          isValid = _ref3.isValid,
          props = _objectWithoutProperties(_ref3, _excluded);

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, onChange ? /*#__PURE__*/_react["default"].createElement(CigaretteChangeListener, {
        values: values,
        initialValues: initialValues,
        isValid: isValid,
        onChange: onChange
      }) : null, /*#__PURE__*/_react["default"].createElement(_styles.StyledForm, {
        className: className,
        $isMobile: isMobile,
        $isWizardOpen: isWizard && !!values.destination,
        $isWizard: isWizard,
        $isWhiteLabel: isWhiteLabel,
        $variant: variant,
        $searchType: searchType
      }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        id: _constants.FIELD_NAMES.destination,
        name: _constants.FIELD_NAMES.destination,
        fullOptions: fullOptions,
        foundGroupedOptions: foundGroupedOptions,
        startOptions: startOptions,
        fetchAutocomplete: setParams,
        fetchPlaces: setDepartureValue,
        className: _constants.LEFT_BORDER_CLASS,
        searchType: searchType,
        variant: variant,
        isWidget: isWidget,
        isOpenInitial: initialOpenedField === _constants.FIELD_NAMES.destination,
        setBodyLocked: setBodyLocked,
        as: _FormDestinationPicker["default"],
        isWhiteLabel: isWhiteLabel,
        isLoading: destinationsLoading
      }), !isTrip && /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        id: _constants.FIELD_NAMES.datepicker,
        name: _constants.FIELD_NAMES.datepicker,
        className: _constants.LEFT_BORDER_CLASS,
        as: _FormDatePicker["default"],
        isWhiteLabel: isWhiteLabel,
        searchType: searchType,
        variant: variant,
        setBodyLocked: setBodyLocked,
        isOpenInitial: initialOpenedField === _constants.FIELD_NAMES.datepicker
      }), !isTrip && /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        id: _constants.FIELD_NAMES.tourists,
        name: _constants.FIELD_NAMES.tourists,
        className: _constants.LEFT_BORDER_CLASS,
        as: _FormTouristsPicker["default"],
        searchType: searchType,
        variant: variant,
        setBodyLocked: setBodyLocked,
        isWhiteLabel: isWhiteLabel,
        isOpenInitial: initialOpenedField === _constants.FIELD_NAMES.tourists,
        isSearcher: isSearcher
      }), isPackage && /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        id: _constants.FIELD_NAMES.departure,
        name: _constants.FIELD_NAMES.departure,
        value: departures,
        className: _constants.LEFT_BORDER_CLASS,
        isLoading: departuresLoading,
        isMainPage: isMainPage,
        variant: variant,
        isWidget: isWidget,
        isOpenInitial: initialOpenedField === _constants.FIELD_NAMES.departure,
        setBodyLocked: setBodyLocked,
        as: _FormDeparturePicker["default"],
        isWhiteLabel: isWhiteLabel
      }), /*#__PURE__*/_react["default"].createElement(_BackWizardButton["default"], null), /*#__PURE__*/_react["default"].createElement(_CloseWizardButton["default"], {
        searchType: searchType,
        setBodyLocked: setBodyLocked
      }), /*#__PURE__*/_react["default"].createElement(_SearchButton["default"], {
        loading: landLoading,
        shouldDisplay: isTrip && Boolean(values.destination),
        isSearcherButton: isSearcher
      })));
    })))
  );
}; // https://github.com/jaredpalmer/formik/issues/2769#issuecomment-845235005


var CigaretteChangeListener = function CigaretteChangeListener(props) {
  var values = props.values,
      initialValues = props.initialValues,
      isValid = props.isValid,
      onChange = props.onChange;

  var _useState = (0, _react.useState)(values),
      _useState2 = _slicedToArray(_useState, 2),
      lastValues = _useState2[0],
      updateState = _useState2[1];

  var handleChange = (0, _react.useCallback)((0, _debounce2["default"])(function (values, changes) {
    onChange(values, changes);
  }, 500, {
    maxWait: 1500
  }), []);
  (0, _react.useEffect)(function () {
    var valuesEqualLastValues = (0, _isMatch2["default"])(values, lastValues);
    var valuesEqualInitialValues = (0, _isMatch2["default"])(values, initialValues);

    if (!valuesEqualLastValues && !valuesEqualInitialValues && isValid) {
      var searchParamsChanges = (0, _utils.getSearchParamsChanges)(lastValues, values);
      handleChange(values, searchParamsChanges);
    }

    if (!valuesEqualLastValues) {
      updateState(values);
    }
  }, [values, isValid]);
  return null;
};
/** для использования как компонента на сайте */


var Cigarette = (0, _withApiContext.withApiContext)( /*#__PURE__*/(0, _react.memo)(BaseCigarette));
/** для использования как виджета */

exports.Cigarette = Cigarette;

var _default = /*#__PURE__*/(0, _react.memo)(BaseCigarette);

exports["default"] = _default;